import React, { useState, useEffect } from "react";
import axios from "axios";

export default function LabForm({ labId }) {
  const [contents, setContents] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    content_id: "",
    content_en: "",
    image: "",
    compile_type: "",
    price: "",
    done: false,
    learn: "",
    free: false,
    payment_link: "",
    qr_code: "",
  });

  // Fetch all contents for dropdown
  useEffect(() => {
    axios.get("/api/v1/content/")
      .then(res => setContents(res.data))
      .catch(err => console.error(err));
  }, []);

  // Fetch existing lab if editing
  useEffect(() => {
    if (labId) {
      axios.get(`/api/v1/lab/${labId}`)
        .then(res => setFormData(prev => ({
          ...prev,
          ...res.data,
          done: res.data.done ? true : false,
          free: res.data.free ? true : false
        })))
        .catch(err => console.error(err));
    }
  }, [labId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (labId) {
        await axios.put(`/api/v1/lab/${labId}`, formData);
        alert("Lab updated successfully!");
      } else {
        const res = await axios.post("/api/v1/lab/", formData);
        alert(`Lab created! ID: ${res.data.lab_id}`);
        setFormData({
          title: "",
          content_id: "",
          content_en: "",
          image: "",
          compile_type: "",
          price: "",
          done: false,
          learn: "",
          free: false,
          payment_link: "",
          qr_code: "",
        });
      }
    } catch (err) {
      console.error(err);
      alert("Error saving lab");
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">{labId ? "Edit Lab" : "Create Lab"}</h2>
      <form onSubmit={handleSubmit}>
        {/* Title */}
        <div className="mb-3">
          <label className="form-label">Title:</label>
          <input
            className="form-control"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        {/* Content dropdown */}
        <div className="mb-3">
          <label className="form-label">Content:</label>
          <select
            className="form-select"
            name="content_id"
            value={formData.content_id}
            onChange={handleChange}
            required
          >
            <option value="">Select Content</option>
            {contents.map(c => (
              <option key={c.id} value={c.id}>{c.title}</option>
            ))}
          </select>
        </div>

        {/* Content editor */}
        <div className="mb-3">
          <label className="form-label">Content (Text/HTML):</label>
          <textarea
            className="form-control"
            name="content_en"
            value={formData.content_en}
            onChange={handleChange}
            rows={6}
            placeholder="Enter content here"
          />
        </div>

        {/* Image URL */}
        <div className="mb-3">
          <label className="form-label">Image URL:</label>
          <input
            className="form-control"
            name="image"
            value={formData.image}
            onChange={handleChange}
          />
        </div>

        {/* Compile Type */}
        <div className="mb-3">
          <label className="form-label">Compile Type:</label>
          <input
            className="form-control"
            name="compile_type"
            value={formData.compile_type}
            onChange={handleChange}
            required
          />
        </div>

        {/* Price */}
        <div className="mb-3">
          <label className="form-label">Price:</label>
          <input
            className="form-control"
            name="price"
            value={formData.price}
            onChange={handleChange}
            required
          />
        </div>

        {/* Done checkbox */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            name="done"
            checked={formData.done}
            onChange={handleChange}
            id="doneCheck"
          />
          <label className="form-check-label" htmlFor="doneCheck">Done</label>
        </div>

        {/* Learn */}
        <div className="mb-3">
          <label className="form-label">Learn:</label>
          <input
            className="form-control"
            name="learn"
            value={formData.learn}
            onChange={handleChange}
            required
          />
        </div>

        {/* Free checkbox */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            name="free"
            checked={formData.free}
            onChange={handleChange}
            id="freeCheck"
          />
          <label className="form-check-label" htmlFor="freeCheck">Free</label>
        </div>

        {/* Payment Link */}
        <div className="mb-3">
          <label className="form-label">Payment Link:</label>
          <input
            className="form-control"
            name="payment_link"
            value={formData.payment_link}
            onChange={handleChange}
            required
          />
        </div>

        {/* QR Code URL */}
        <div className="mb-3">
          <label className="form-label">QR Code URL:</label>
          <input
            className="form-control"
            name="qr_code"
            value={formData.qr_code}
            onChange={handleChange}
            required
          />
        </div>

        {/* Submit button */}
        <button type="submit" className="btn btn-primary">
          {labId ? "Update Lab" : "Create Lab"}
        </button>
      </form>
    </div>
  );
}
